<template>
  <div v-if="preserveAspectRatio" class="Image" :style="`--height: ${100 * ratio}%`">
    <img 
        class="Image-img" 
        :srcset="srcset"
        :sizes="`(max-width: 768px) 100vw, ${width}px`"
        :width="width"
        :height="height"
        :alt="alt" 
        :loading="loading">
  </div>
  <img v-else
    :srcset="srcset"
    :sizes="`(max-width: 768px) 100vw, ${width}px`"
    :width="width"
    :height="height"
    :alt="alt" 
    :loading="loading">
</template>

<script>
export default {
  props: {
    imgId: {
      type: Number,
      default: null
    },
    width: Number,
    height: Number,
    alt: String,
    imageSizes: {
      type: Array,
      default: () => [240,480,768,1080,1280,1680,1920]
    },
    loading: {
      type: String,
      default: 'lazy'
    },
    category: String,
    preserveAspectRatio: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    ratio() {
      return this.height / this.width;
    },

    srcset() {
      const srcset = this.imageSizes.map( width => {
        const height = Math.round(width * this.ratio);
        return `/api/images/${this.imgId}?width=${width}&height=${height} ${width}w` 
      }).join(', ');

      return srcset;
    }
  }
}
</script>